module.exports = __webpack_public_path__ + "static/media/slide-image-2.02652a18.jpg";